export default {"src":"/_next/static/media/check.f97b5712.svg","height":40,"width":40};